import React from 'react';
import PriceList from 'components/Tvendo/Article/DataMaster/PriceList/PriceList';
export default function () {
  return <PriceList />;
}
